import { render, staticRenderFns } from "./BulkProjectCard.vue?vue&type=template&id=0dd4472c&"
import script from "./BulkProjectCard.vue?vue&type=script&lang=ts&"
export * from "./BulkProjectCard.vue?vue&type=script&lang=ts&"
import style0 from "./BulkProjectCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports